var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediaNode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18490_135181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.667 9.99935C16.667 13.6812 13.6822 16.666 10.0003 16.666M16.667 9.99935C16.667 6.31745 13.6822 3.33268 10.0003 3.33268M16.667 9.99935H3.33366M10.0003 16.666C6.31843 16.666 3.33366 13.6812 3.33366 9.99935M10.0003 16.666C11.6678 14.8404 12.616 12.4713 12.6675 9.99935C12.616 7.52737 11.6678 5.15825 10.0003 3.33268M10.0003 16.666C8.33281 14.8404 7.38562 12.4713 7.33412 9.99935C7.38562 7.52737 8.33281 5.15825 10.0003 3.33268M3.33366 9.99935C3.33366 6.31745 6.31843 3.33268 10.0003 3.33268M5.00033 16.666C5.00033 17.5865 4.25413 18.3327 3.33366 18.3327C2.41318 18.3327 1.66699 17.5865 1.66699 16.666C1.66699 15.7455 2.41318 14.9993 3.33366 14.9993C4.25413 14.9993 5.00033 15.7455 5.00033 16.666ZM18.3337 16.666C18.3337 17.5865 17.5875 18.3327 16.667 18.3327C15.7465 18.3327 15.0003 17.5865 15.0003 16.666C15.0003 15.7455 15.7465 14.9993 16.667 14.9993C17.5875 14.9993 18.3337 15.7455 18.3337 16.666ZM5.00033 3.33268C5.00033 4.25316 4.25413 4.99935 3.33366 4.99935C2.41318 4.99935 1.66699 4.25316 1.66699 3.33268C1.66699 2.41221 2.41318 1.66602 3.33366 1.66602C4.25413 1.66602 5.00033 2.41221 5.00033 3.33268ZM18.3337 3.33268C18.3337 4.25316 17.5875 4.99935 16.667 4.99935C15.7465 4.99935 15.0003 4.25316 15.0003 3.33268C15.0003 2.41221 15.7465 1.66602 16.667 1.66602C17.5875 1.66602 18.3337 2.41221 18.3337 3.33268Z",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18490_135181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaNode);
export default __webpack_public_path__ + "static/media/mediaNode.b6fbc8cd51aa953166fe67f171e68201.svg";
export { ForwardRef as ReactComponent };